module.exports = __webpack_public_path__ + "img/icon20.3c998d74.svg";